import React from 'react';
import moment from 'moment';

const CampaignScheduleComponent = ({ startdate, enddate }) => {
  return (
    <div className="row campaign_details_base">
      <div className="col-md-6">
        <p>Start Date</p>
        <h6>{`${moment(startdate).format('Do MMM YYYY hh:mm a')}` || 'n/a'}</h6>
      </div>
      <div className="col-md-6">
        <p>End Date</p>
        <h6>{`${moment(enddate).format('Do MMM YYYY hh:mm a')}` || 'n/a'}</h6>
      </div>
    </div>
  );
};

export default CampaignScheduleComponent;
